import React, { useContext } from 'react'
import { SlidePromptThemeEditor } from './themes/slide-prompt-theme-editor'
import { PromptEditorTreatment } from '../types'
import { PromptAbVariantDetails } from './prompt-ab-variant-details'
import { PromptStyleSelector } from './prompt-style-selector'
import { PromptBehaviorEditor } from './prompt-behavior-editor'
import { PromptVisitorConditionsEditor } from './prompt-visitor-conditions-editor'
import {
    CreateSlidePromptRequest,
    isCreateSlidePromptRequest,
    isUpdateSlidePromptRequest,
} from '@pushly/models/lib/structs/prompts/styles/slide/slide-prompt'
import {
    isCreateCustomPromptRequest,
    isUpdateCustomPromptRequest,
} from '@pushly/models/lib/structs/prompts/styles/custom/custom-prompt'
import { PromptStyle } from '@pushly/models/lib/enums/prompts/prompt-style'
import { CreateNativePromptRequest } from '@pushly/models/lib/structs/prompts/styles/native/native-prompt'
import { CreateCustomPromptRequest } from '@pushly/models/lib/structs'
import { toPrompt } from '../helpers'
import { PromptEditorDispatchContext } from '../reducer'
import { PromptEditorContext } from '../context'
import { SlidePromptConfig } from '@pushly/models/lib/structs/prompts/styles/slide/slide-prompt-config'

export const PromptTreatmentEditor = () => {
    const dispatch = useContext(PromptEditorDispatchContext)
    const { loading, domain, selectedPrompt, selectedPromptIdx, isAbTestEnabled } = useContext(PromptEditorContext)

    return (
        <div className="treatment-form">
            {isAbTestEnabled && <PromptAbVariantDetails />}

            <PromptStyleSelector
                loading={loading}
                value={selectedPrompt?.style ?? PromptStyle.NATIVE}
                onChange={(style) => {
                    if (loading) return

                    let update: PromptEditorTreatment
                    switch (style) {
                        case PromptStyle.SLIDE: {
                            const slide = toPrompt(CreateSlidePromptRequest, selectedPrompt)
                            // switching to prompt should assign domain.defaultIconUrl to image
                            slide.config!.theme!.image = domain.defaultIconUrl
                            update = slide
                            break
                        }

                        case PromptStyle.PUBLISHER_CUSTOM: {
                            update = toPrompt(CreateCustomPromptRequest, selectedPrompt)
                            break
                        }

                        case PromptStyle.NATIVE:
                        default: {
                            update = toPrompt(CreateNativePromptRequest, selectedPrompt)
                            break
                        }
                    }

                    dispatch({ type: 'set-prompt', idx: selectedPromptIdx, prompt: update })
                }}
            />

            {(isCreateSlidePromptRequest(selectedPrompt) || isUpdateSlidePromptRequest(selectedPrompt)) && (
                <SlidePromptThemeEditor
                    value={selectedPrompt.config?.theme}
                    onChange={(theme) => {
                        if (loading) return
                        const update = selectedPrompt.clone()
                        update.config ??= new SlidePromptConfig()
                        update.config.theme = theme
                        dispatch({ type: 'set-prompt', idx: selectedPromptIdx, prompt: update })
                    }}
                />
            )}

            {!isCreateCustomPromptRequest(selectedPrompt) && !isUpdateCustomPromptRequest(selectedPrompt) && (
                <PromptBehaviorEditor />
            )}

            <PromptVisitorConditionsEditor />
        </div>
    )
}
